import {
  type IEngineRuntimeSection,
  type IEngineSection,
} from '../../../schema/sections/IEngineSection.ts';

/**
 * Ritorna vero se la sezione con id fornito è disabilitata.
 */
export function isRuntimeSectionDisabled(
  runtimeSections: Array<IEngineRuntimeSection<IEngineSection>>,
  sectionId: string | null | undefined,
) {
  return runtimeSections.find(s => s.section.id == sectionId)?.enabled == false;
}
